import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../constants'
import * as reports from './reports'
import * as stages from './stages'
import * as teams from './teams'
import * as tournament from './tournament'

export * as reports from './reports'
export * as stages from './stages'
export * as teams from './teams'
export * as tournament from './tournament'

export const actions = {
  ...reports.actions,
  ...stages.actions,
  ...teams.actions,
  ...tournament.actions,
}

export const epics = [...reports.epics, ...stages.epics, ...teams.epics, ...tournament.epics]

export const reducer = combineReducers({
  reports: reports.reducer,
  stages: stages.reducer,
  teams: teams.reducer,
  tournament: tournament.reducer,
})

export const selectors = {
  reports: Object.assign(
    ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.reports,
    reports.selectors,
  ),
  stages: Object.assign(
    ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.stages,
    stages.selectors,
  ),
  teams: Object.assign(
    ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.teams,
    teams.selectors,
  ),
  tournament: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.tournament,
}
